import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { ReferenceVoucherListComponent } from "../../invvoucher/reference-voucher-list/reference-voucher-list.component";
import { InvVoucherKind } from "../../models/inv-voucher-kind.model";

@Component({
  selector: "ngx-inv-no-reference-voucher-form",
  templateUrl: "./inv-no-reference-voucher-form.component.html",
  styleUrls: ["./inv-no-reference-voucher-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvNoReferenceVoucherFormComponent extends BaseFormComponent<any> {
  voucherKind: InvVoucherKind;
  ReferenceVoucherKindIds: number[] = [];
  ReferenceVoucherKind: InvVoucherKind[];
  dataList: any[] = [];
  SelectedRow: any;
  @ViewChild(KGridComponent) grid: KGridComponent;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "InvVoucherHeader/GetInvNoReferenceVoucher";
    this.label = "اسناد بدون معطوف";
    this.setColumns();
    this.formGroup = new UntypedFormGroup({});
    this.setdefault();
    this.addControl();
  }
  setdefault() {
    this.setValue("VoucherKindId", null, true);
    this.setValue("ReferenceVoucherKindIds", this.ReferenceVoucherKindIds, true);
    this.setValue("ShowReference", false, true);
    this.setValue("LinearReferenced", false, true);
  }
  onRowSelected($event) {
    this.voucherKind = $event;
    if (this.voucherKind.IsWarehouse === true) {
      this.apiName = "InvVoucherHeader/GetInvNoReferenceVoucher";
      this.grid.apiName = this.apiName;
    } else {
      this.apiName = "SellVoucherHeader/GetInvNoReferenceVoucher";
      this.grid.apiName = this.apiName;
    }

    this.setReferenceVoucherKind();
  }
  setReferenceVoucherKind() {
    this.httpCommonService
      .get("InvVoucherKind/GetReferenceVoucherKind/?id=" + this.voucherKind.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: InvVoucherKind[]) => {
          this.ReferenceVoucherKind = data;
        },
        (error) => this.getFailedHelper(error)
      );
  }
  onChange($event) {
    let FiscalYearId: number = this.accountService.authService.currentFiscalYear?.Id;
    if (this.grid && this.formGroup.get("ReferenceVoucherKindIds").value && this.formGroup.get("ReferenceVoucherKindIds").value.length > 0) {
      this.grid.filters = this.getGridFilter();
      this.grid.refreshData();
    }
  }
  async setColumns() {
    this.orignalColumns = [];

    this.httpCommonService
      .get("InvVoucherHeader/GetReferenceVoucherInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: form_control[]) => {
          this.columns = data.filter((x) => x.name != "DiscountAmount" && x.name !== "Tax" && x.name !== "Surplusage" && x.name !== "Deduction");
          this.columns = (data as form_control[]).sort((a, b) => a.order - b.order);
        },
        (error) => this.getFailedHelper(error)
      );
  }
  getGridFilter(Skip: number = 0, Take: number = 10): GridFilter[] {
    let gridFilter: GridFilter[] = [];

    gridFilter = [
      {
        Type: "F",
        Filed: "ReferenceVoucherKindIds",
        Value: this.formGroup.get("ReferenceVoucherKindIds").value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 10,
      },
      {
        Type: "F",
        Filed: "BranchId",
        Value: this.accountService.authService.currentBranchId,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 10,
      },
      {
        Type: "F",
        Filed: "ShowReference",
        Value: !this.formGroup?.get("ShowReference")?.value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 10,
      },
      {
        Type: "F",
        Filed: "LinearReferenced",
        Value: this.formGroup?.get("LinearReferenced")?.value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 10,
      },
      {
        Type: "F",
        Filed: "VoucherKindId",
        Value: this.formGroup.get("VoucherKindId").value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 10,
      },
      {
        Type: "F",
        Filed: "FiscalYearId",
        Value: this.accountService.authService.currentFiscalYear?.Id,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 10,
      },
    ];
    return gridFilter;
  }
  addControl() {
    this.formGroup?.controls["ShowReference"].valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && this.formGroup?.get("LinearReferenced").value) {
        this.formGroup?.get("LinearReferenced").setValue(false);
        this.cd.markForCheck();
      }
    });
    this.formGroup?.controls["LinearReferenced"].valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && this.formGroup?.get("ShowReference").value) {
        this.formGroup?.get("ShowReference").setValue(false);
        this.cd.markForCheck();
      }
    });
  }
  onRow_Selected($event) {
    this.SelectedRow = $event;
  }
  ReferenceTo() {
    if (!this.SelectedRow || !this.SelectedRow["VoucherHeaderId"]) return;
    this.dialogService
      .open(
        ReferenceVoucherListComponent,
        {
          VoucherId: this.SelectedRow["VoucherHeaderId"],
          apiName: "InvVoucherHeader/GetInvReferenceToVouchersByVoucherId",
          areaName: "Inventory",
          label: "سند معطوف",
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {});
  }
  Reference() {
    if (!this.SelectedRow || !this.SelectedRow["ReferenceVoucherHeaderId"]) return;

    this.dialogService
      .open(
        ReferenceVoucherListComponent,
        {
          VoucherId: this.SelectedRow["ReferenceVoucherHeaderId"],
          apiName: "InvVoucherHeader/GetInvReferenceVouchersByVoucherId",
          areaName: "Inventory",
          label: "سند مبنا",
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {});
  }
}
